import newMessageInSupportChat from "./newMessageInSupportChat.mp3";
import newReturnRequestNotification from "./newReturnRequestNotification.mp3";
import placedOrderSound from "./placedOrderNotification.mp3";

export const SOUNDS = {
  PLACED_ORDER: new Audio(placedOrderSound),
  RETURN_REQUESTED: new Audio(newReturnRequestNotification),
  NEW_MESSAGE_IN_SUPPORT_CHAT: new Audio(newMessageInSupportChat)
};
